<div class="w-100">
    <app-loader *ngIf="showLoader"></app-loader>
    <ejs-grid
        #proposalGrid
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 20 }"
        [gridLines]="false"
        [allowFiltering]="true"
        [showColumnChooser]="true"
        [height]="gridHeight"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [allowExcelExport]="true"
        [allowSelection]="true"
        [searchSettings]="searchSettings"
        [sortSettings]="sortOptions"
        [editSettings]="{ allowEditing: false }"
        [filterSettings]="{ type: 'Menu' }"
        (toolbarClick)="onToolbarClick($event)"
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="commandClick($event, proposalGrid)"
        (created)="created()"
        (actionComplete)="onGridActionComplete($event, proposalGrid)"
        >
        <e-columns>
            <e-column
                *ngFor="let column of columns;"
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting ?? true"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                <ng-template *ngIf="column.field === 'statusText'" #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
                </ng-template>
                <ng-template *ngIf="column.field === 'proposalId'" #template let-data>
                  <i class="fas" [ngClass]="{ 'fa-circle-check color-green': data.isActive, 'fa-ban color-red': !data.isActive }" [title]="data.isActive ? 'Active': 'Inactive'"></i>
                  <a href="javascript:" (click)="openProposalPopup(null, null, data.proposalId)">
                    {{ data.proposalId }}
                  </a>
                </ng-template>
                <ng-template *ngIf="column.field === 'businessPartner'" #template let-data>
                  <a href="javascript:" (click)="onBPIdClick(data.soldToBP)">{{data.businessPartner}}</a>
                </ng-template>
                <ng-template *ngIf="column.field === 'customer'" #template let-data>
                  <a href="javascript:" (click)="openProspectPopup(data.customerId)">{{data.customer}}</a>
                </ng-template>
                <ng-template *ngIf="column.field === 'salesLeadId'" #template let-data>
                  <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
                </ng-template>
                <ng-template *ngIf="column.field === 'accountName'" #template let-data>
                  <a *ngIf="data.accountName" href="javascript:" (click)="openDistributorPopup(data)">{{data.accountName}}</a>
                </ng-template>
            </e-column>
        </e-columns>
    </ejs-grid>
  </div>

  <ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
    ></app-column-chooser>
  </ng-template>

  <ng-template #addLeads>
    <i *ngIf="rolePermissions['proposalGrid_add']?.visible" class="fas fa-add"></i>
  </ng-template>

  <app-prospects-popup
  *ngIf="showProspectsPopup"
    [prospectData]="prospectData"
    [tab]="'details'"
    (onClose)="showProspectsPopup = false"
    >
  </app-prospects-popup>
